import Core from "Core";

export class CustomersStore extends Core.Stores.ModelStore {
  constructor(modelType, store) {
    super(modelType, "/api/public/customers.php", store);
  }

  beforeUpdateFromJson() {
    this.clear();
  }
}



// WEBPACK FOOTER //
// ./src/Stores/DataStore/CustomersStore.js